import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push, goBack } from 'react-router-redux';
import { fromJS } from 'immutable';
import diff from 'immutablediff';
import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import qs from '../../modules/normalizingQs';

import {
  getProduct,
  updateProduct,
  createProduct,
  getProductOptions,
  getFurniture,
  updateStockStatusProduct,
} from '../../ducks/product';
import {
  loadingSelector, productSelector, productOptionsSelector, furnitureSelector,
} from '../../ducks/product';

import Spinner from '../../Components/Shared/Spinner';
import {
  Header, AttributesForm, ImagesContainer, GlobalButtons,
} from '../../Components/Product';

toastr.options = {
  positionClass: 'toast-top-right',
  timeOut: 3000,
  closeButton: true,
};

const defaultState = {
  furniture: {
    arm_height: '',
    color_ids: [],
    cost_cad: '',
    cost_usd: '',
    material_ids: [],
    seat_depth: '',
    seat_height: '',
    seat_width: '',
    weight: '',
  },
  id: 0,
  images: {},
  product: {
    active: false,
    cad_price: '',
    default_image: { medium: { url: '' } },
    depth: '',
    description: '',
    height: '',
    image2: { medium: { url: '' } },
    image3: { medium: { url: '' } },
    image4: { medium: { url: '' } },
    image5: { medium: { url: '' } },
    image6: { medium: { url: '' } },
    name: '',
    product_attributes_array: [],
    sku: '',
    is_assembly_required: 'need to check',
    is_discontinued: '',
    stock_number: '',
    eta_date: '',
    inventories: [],
    supplier_id: '',
    tax_rate_id: '',
    url_default_image: '',
    url_image2: '',
    url_image3: '',
    url_image4: '',
    url_image5: '',
    url_image6: '',
    usd_price: '',
    width: '',
  },
  product_category_ids: [],
};

export class Product extends Component {
  state = {
    categories: [],
    colors: [],
    delete_attribute_ids: [],
    hasProduct: false,
    materials: [],
    missingRequiredFields: false,
    productData: defaultState,
    suppliers: [],
    fxCad: null,
  };

  componentDidMount() {
    window.scrollTo(0, 0);

    const { getProductOptions, match, location } = this.props;
    getProductOptions();

    const queryParams = qs.parse(location.search);
    const productIndex = parseInt(queryParams.productIndex, 10);
    const scrapedProducts = JSON.parse(sessionStorage.getItem('scrapedProducts') || '[]');

    if (match.params.id === 'tmp_etl' && !isNaN(productIndex) && scrapedProducts[productIndex]) {
      this.updateProductData({ product: scrapedProducts[productIndex] });
    } else if (match.params.id && match.params.id !== '0') {
      this.props.getProduct(match.params.id);
    } else {
      this.setState({ hasProduct: true, productData: defaultState });
    }

    axios.get('settings/fx_cad')
      .then(response => {
        this.setState({ fxCad: parseFloat(response.data.value) });
      })
      .catch(error => console.error('Error fetching fx_cad:', error));
  }

  componentWillUnmount() {
    sessionStorage.removeItem('scrapedProducts');
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.product !== this.props.product ||
      nextProps.productOptions !== this.props.productOptions ||
      nextState.productData !== this.state.productData ||
      nextState.fxCad !== this.state.fxCad ||
      nextState.missingRequiredFields !== this.state.missingRequiredFields;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // Ignore Redux updates for /products/0
    if (this.props.match.params.id !== '0' && nextProps.product && !this.state.hasProduct && !nextProps.location.search.includes('productIndex')) {
      this.updateProductData(nextProps);
    }

    if (nextProps.productOptions) {
      this.setState({
        categories: nextProps.productOptions.categories || [],
        colors: nextProps.productOptions.colors || [],
        materials: nextProps.productOptions.materials || [],
        suppliers: nextProps.productOptions.suppliers || [],
      });
    }

    // Handle backend errors
    if (nextProps.error && nextProps.error !== this.props.error) {
      const errorMessage = nextProps.error.response?.data?.error || 'An error occurred';
      toastr.error('Failed', errorMessage);
    }
  }

  updateProductData = (nextProps) => {
    const productData = this.getProductData(nextProps);
    this.setState({
      hasProduct: true,
      productData,
      missingRequiredFields: !this.hasRequiredFields(productData),
    });
  };

  getProductData = (data) => {
    let results = { ...defaultState };
    if (data.product) {
      results = {
        ...defaultState,
        furniture: {
          ...defaultState.furniture,
          ...data.product.furniture,
          cost_cad: this.state.productData.furniture.cost_cad || data.product.furniture?.cost_cad || '',
          cost_usd: this.state.productData.furniture.cost_usd || data.product.furniture?.cost_usd || '',
          color_ids: data.product.furniture?.colors || [],
          material_ids: data.product.furniture?.materials || [],
        },
        id: data.product.id,
        images: {},
        product: {
          ...defaultState.product,
          active: data.product.active,
          default_image: data.product.default_image || { medium: { url: '' } },
          depth: data.product.depth || 0,
          description: data.product.description || '',
          height: data.product.height || 0,
          image2: data.product.image2 || { medium: { url: '' } },
          image3: data.product.image3 || { medium: { url: '' } },
          image4: data.product.image4 || { medium: { url: '' } },
          image5: data.product.image5 || { medium: { url: '' } },
          image6: data.product.image6 || { medium: { url: '' } },
          name: data.product.name || '',
          product_attributes_array: data.product.product_attributes || [],
          sku: data.product.sku || '',
          is_assembly_required: data.product.is_assembly_required == 'Yes' ? 'yes' :
            data.product.is_assembly_required == 'Yes - Light Assembly' ? 'yes_light_assembly' :
              data.product.is_assembly_required == 'Yes - KD' ? 'yes_kd' :
                data.product.is_assembly_required == 'No' ? 'no' :
                  data.product.is_assembly_required == 'Need to Check' ? 'need_to_check' :
                    'need to check',
          is_discontinued: data.product.is_discontinued || '',
          stock_number: data.product.stock_number || '',
          eta_date: data.product.eta_date || '',
          inventories: data.product.inventories || [],
          supplier_id: data.product.supplier_id || '',
          url_default_image: data.product.url_default_image || '',
          url_image2: data.product.url_image2 || '',
          url_image3: data.product.url_image3 || '',
          url_image4: data.product.url_image4 || '',
          url_image5: data.product.url_image5 || '',
          url_image6: data.product.url_image6 || '',
          usd_price: this.state.productData.product.usd_price || data.product.msrp_usd || '',
          cad_price: this.state.productData.product.cad_price || data.product.msrp_cad || '',
          width: data.product.width || 0,
        },
        product_category_ids: data.product.categories || [],
        room_variants: data.product.room_variants || [],
      };
    }
    return results;
  };

  getEtlProductData = (data) => {
    return { ...defaultState };
  };

  getUpdateData = (productData) => {
    const result = {
      furniture: {
        cost_cad: productData.furniture.cost_cad,
        cost_usd: productData.furniture.cost_usd,
        weight: productData.furniture.weight,
      },
      images: {},
      product: {
        name: productData.product.name,
        sku: productData.product.sku,
        supplier_id: productData.product.supplier_id,
        is_assembly_required: productData.product.is_assembly_required,
        cad_price: productData.product.cad_price,
        usd_price: productData.product.usd_price,
        width: productData.product.width,
        depth: productData.product.depth,
        height: productData.product.height,
      },
      product_category_ids: productData.product_category_ids,
    };
    const oldData = this.getProductData(this.props);
    const oldEtlData = this.getEtlProductData(this.props);

    const { match } = this.props;
    const product_id = match.params.id;

    if (product_id.includes('tmp')) {
      const updateFields = diff(fromJS(oldEtlData), fromJS(productData)).toJS();

      for (const item of updateFields) {
        const path = item.path.split('/');
        const group = path[1];
        const key = path[2];
        if (['color_ids', 'material_ids'].includes(key)) {
          if (productData[group][key].length > 0) {
            result[group][key] = productData[group][key];
          }
        } else if (['product_attributes_array'].includes(key)) {
          if (productData[group][key].length > 0) {
            result[group][key] = productData[group][key];
          }
        } else if (['product_category_ids'].includes(group)) {
          if (productData[group].length > 0) {
            result[group] = productData[group];
          }
        } else if (['delete_attribute_ids'].includes(group)) {
          if (productData[group].length > 0) {
            result.product[group] = productData[group];
          }
        } else {
          const unused_params = ['id', 'colors', 'materials', 'image2', 'image3', 'image4', 'image5', 'image6', 'default_image'];
          if (key !== undefined && group.length > 0 && !unused_params.includes(key)) {
            result[group][key] = item.value;
          }
        }
      }
    } else {
      const updateFields = diff(fromJS(oldData), fromJS(productData)).toJS();

      for (const item of updateFields) {
        const path = item.path.split('/');
        const group = path[1];
        const key = path[2];
        if (['color_ids', 'material_ids'].includes(key)) {
          result[group][key] = productData[group][key];
        } else if (['product_attributes_array'].includes(key)) {
          result[group][key] = productData[group][key];
        } else if (['product_category_ids'].includes(group)) {
          result[group] = productData[group];
        } else if (['delete_attribute_ids'].includes(group)) {
          result.product[group] = productData[group];
        } else {
          result[group][key] = item.value;
        }
      }
    }

    if (result.images.default_image) {
      result.product.default_image = result.images.default_image;
    }
    delete result.images;
    if (!Object.keys(result.furniture).length) {
      delete result.furniture;
    }

    return result;
  };

  getUrlKey = (key) => (key === 1 ? 'url_default_image' : `url_image${key}`);

  getFileKey = (key) => (key === 1 ? 'default_image' : `image${key}`);

  getImagesList = (productData) => {
    const indexList = [1, 2, 3, 4, 5];
    return indexList.map((key) => {
      const url = productData.product[`${this.getUrlKey(key)}`];
      const file = productData.product[`${this.getFileKey(key)}`];
      const isFile = (file && file.type) || (file && file.medium && file.medium.url);
      return isFile ? this.getImageData(file) : url;
    });
  };

  getImageData = (file) => (file.type ? URL.createObjectURL(file) : file.medium.url);

  hasRequiredFields = (productData = this.state.productData) => {
    const { product_category_ids, product, furniture } = productData;
    const {
      name,
      sku,
      supplier_id,
      is_assembly_required,
      usd_price,
      width,
      depth,
      height,
    } = product;
    const { cost_usd, weight } = furniture;

    return (
      product_category_ids.length > 0 &&
      name !== '' && name !== null && name !== undefined &&
      sku !== '' && sku !== null && sku !== undefined &&
      supplier_id !== '' && supplier_id !== null && supplier_id !== undefined &&
      is_assembly_required !== '' && is_assembly_required !== null && is_assembly_required !== undefined &&
      usd_price !== '' && usd_price !== null && usd_price !== undefined &&
      cost_usd !== '' && cost_usd !== null && cost_usd !== undefined &&
      width !== '' && width !== null && width !== undefined &&
      depth !== '' && depth !== null && depth !== undefined &&
      height !== '' && height !== null && height !== undefined &&
      weight !== '' && weight !== null && weight !== undefined
    );
  };

  getValidationErrors = () => {
    const { product_category_ids, product, furniture } = this.state.productData;
    const {
      name,
      sku,
      supplier_id,
      is_assembly_required,
      usd_price,
      width,
      depth,
      height,
    } = product;
    const { cost_usd, weight } = furniture;

    const errors = [];
    if (product_category_ids.length === 0) errors.push("Categories");
    if (!name) errors.push("Name");
    if (!sku) errors.push("SKU");
    if (!supplier_id) errors.push("Supplier");
    if (!is_assembly_required) errors.push("Is Assembly Required");
    if (!usd_price) errors.push("MSRP USD");
    if (!cost_usd) errors.push("Cost USD");
    if (!width) errors.push("Width");
    if (!depth) errors.push("Depth");
    if (!height) errors.push("Height");
    if (!weight) errors.push("Weight");

    return errors;
  };

  handleCategoryChange = (categories) => {
    const newProductData = fromJS(this.state.productData).toJS();
    newProductData.product_category_ids = categories;
    this.setState({
      productData: newProductData,
      missingRequiredFields: !this.hasRequiredFields(newProductData),
    });
  };

  handleImagesChange = (file, url, index) => {
    const newProductData = fromJS(this.state.productData).toJS();
    newProductData.product[this.getFileKey(index + 1)] = file || '';
    if (!file) {
      newProductData.product[this.getUrlKey(index + 1)] = url || '';
    }
    if (!file && !url) {
      newProductData.product[`remove_${this.getFileKey(index + 1)}`] = true;
    }
    this.setState({
      productData: newProductData,
      missingRequiredFields: !this.hasRequiredFields(newProductData),
    });
  };

  handleChangeRoomPlannerImage = (file, url) => {
    const newProduct = fromJS(this.state.productData).toJS();
    newProduct.product.image6 = file || '';
    if (!file) {
      newProduct.product.url_image6 = url || '';
    }
    if (!file && !url) {
      newProduct.product.remove_image6 = true;
    }
    this.setState({
      productData: newProduct,
      missingRequiredFields: !this.hasRequiredFields(newProduct),
    });
  };

  handleSupplierChange = (elements) => {
    const newProductData = fromJS(this.state.productData).toJS();
    newProductData.product.supplier_id = elements.value;
    this.setState({
      productData: newProductData,
      missingRequiredFields: !this.hasRequiredFields(newProductData),
    });
  };

  handleDiscontinuedChange = (element) => {
    const newProductData = fromJS(this.state.productData).toJS();
    newProductData.product.is_discontinued = element;
    this.setState({
      productData: newProductData,
      missingRequiredFields: !this.hasRequiredFields(newProductData),
    });
  };

  handleColorsChange = (elements) => {
    const newProductData = fromJS(this.state.productData).toJS();
    newProductData.furniture.color_ids = elements.map((el) => el.value);
    this.setState({
      productData: newProductData,
      missingRequiredFields: !this.hasRequiredFields(newProductData),
    });
  };

  handleMaterialsChange = (elements) => {
    const newProductData = fromJS(this.state.productData).toJS();
    newProductData.furniture.material_ids = elements.map((el) => el.value);
    this.setState({
      productData: newProductData,
      missingRequiredFields: !this.hasRequiredFields(newProductData),
    });
  };

  handleChangeAttributes = (e) => {
    const { name, value, files } = e.target;
    const newProductData = fromJS(this.state.productData).toJS();

    if (files && files[0]) {
      this.setNewImage('image6', files[0]);
      return;
    }

    if (name === 'multiple') {
      Object.entries(value).forEach(([key, val]) => {
        if (key.startsWith('product.')) {
          newProductData.product[key.substring(8)] = val.toString();
        } else if (key.startsWith('furniture.')) {
          newProductData.furniture[key.substring(10)] = val.toString();
        }
      });
    } else {
      const prices = ['product.cad_price', 'product.usd_price', 'furniture.cost_cad', 'furniture.cost_usd'];
      let parsedValue = value;
      if (prices.includes(name) && typeof value === 'string' && value.indexOf('$') !== -1) {
        parsedValue = parseFloat(value.slice(2));
      }
      if (name.startsWith('product')) {
        newProductData.product[name.substring(8)] = parsedValue.toString();
      } else if (name.startsWith('furniture')) {
        newProductData.furniture[name.substring(10)] = parsedValue.toString();
      }
    }

    this.setState({
      productData: newProductData,
      missingRequiredFields: !this.hasRequiredFields(newProductData),
    });
  };

  handleChangeOtherAttributes = (e) => {
    const { name, value } = e;
    let newProduct = fromJS(this.state.productData);
    const itemNumber = name.split(':')[1];
    const itemKey = name.split(':')[0] === 'name ' ? 'key' : 'value';
    const newAttr = newProduct.toJS().product.product_attributes_array;
    newAttr[itemNumber][itemKey] = value;
    newProduct = newProduct.setIn(['product', 'product_attributes_array'], newAttr);
    this.setState({
      productData: newProduct.toJS(),
      missingRequiredFields: !this.hasRequiredFields(newProduct.toJS()),
    });
  };

  handleReturn = () => {
    this.props.goBack();
  };

  handleSave = () => {
    if (!this.hasRequiredFields()) {
      const errors = this.getValidationErrors();
      toastr.error(`Please fill in the following required fields: ${errors.join(', ')}`);
      this.setState({
        missingRequiredFields: true,
      });
      return;
    }
    const { productData, delete_attribute_ids } = this.state;
    const newProduct = { ...productData, delete_attribute_ids, product: { ...productData.product, active: true } };

    const { match } = this.props;
    const formData = this.getUpdateData(newProduct);

    if (match.params.id === 'tmp_etl' || match.params.id === '0') {
      this.props.createProduct(formData);
    } else {
      this.props.updateProduct(productData.id, formData);
    }
  };

  handleAddAttribute = () => {
    let newProduct = fromJS(this.state.productData);
    const OtherAttr = this.state.productData.product.product_attributes_array.slice();
    const newItem = { key: '', value: '' };
    OtherAttr.push(newItem);
    newProduct = newProduct.setIn(['product', 'product_attributes_array'], OtherAttr);
    this.setState({
      productData: newProduct.toJS(),
      missingRequiredFields: !this.hasRequiredFields(newProduct.toJS()),
    });
  };

  handleDeleteAttribute = (id, attributeId) => {
    const newProductData = fromJS(this.state.productData).toJS();
    newProductData.product.product_attributes_array.splice(id, 1);
    this.setState({
      delete_attribute_ids: [...this.state.delete_attribute_ids, attributeId],
      productData: newProductData,
      missingRequiredFields: !this.hasRequiredFields(newProductData),
    });
  };

  handleChangeSwitch = (e) => {
    const newProduct = fromJS(this.state.productData).toJS();
    newProduct.product.active = e;
    this.setState({
      productData: newProduct,
      missingRequiredFields: !this.hasRequiredFields(newProduct),
    });
  };

  setNewImage = (name, file) => {
    const newProduct = fromJS(this.state.productData).toJS();
    newProduct.images[name] = file;
    this.setState({
      productData: newProduct,
      missingRequiredFields: !this.hasRequiredFields(newProduct),
    });
  };

  setNewProduct = (name, value) => {
    const newProduct = fromJS(this.state.productData).toJS();
    const category = name.substring(8);
    newProduct.product[category] = value;
    this.setState({
      productData: newProduct,
      missingRequiredFields: !this.hasRequiredFields(newProduct),
    });
  };

  setNewFurniture = (name, value) => {
    const newProduct = fromJS(this.state.productData).toJS();
    const category = name.substring(10);
    newProduct.furniture[category] = value;
    this.setState({
      productData: newProduct,
      missingRequiredFields: !this.hasRequiredFields(newProduct),
    });
  };

  buttonClone_clickHandler = (event) => {
    const { match } = this.props;
    event && event.preventDefault && event.preventDefault();
    window.open(`/products/clone/${match.params.id}`);
  };

  buttonStockStatus_clickHandler = (event) => {
    const { updateStockStatusProduct, match } = this.props;
    updateStockStatusProduct(match.params.id);
  };

  handleSwap = (index) => {
    const newProductData = { ...this.state.productData };
    const pd = newProductData.product;
    const keyNum = index + 1;

    const tempFile = pd.default_image;
    const tempUrl = pd.url_default_image;
    const tempRemove = pd.remove_default_image;

    pd.default_image = pd[`image${keyNum}`];
    pd.url_default_image = pd[`url_image${keyNum}`];
    pd.remove_default_image = pd[`remove_image${keyNum}`];

    pd[`image${keyNum}`] = tempFile;
    pd[`url_image${keyNum}`] = tempUrl;
    pd[`remove_image${keyNum}`] = tempRemove;

    this.setState({ productData: newProductData });
  };

  render() {
    if (this.props.loading || !this.state.productData || !this.props.productOptions) {
      return <Spinner />;
    }
    const {
      productData, categories, colors, materials, suppliers, missingRequiredFields, fxCad
    } = this.state;

    const { push } = this.props;
    const { id } = this.props.match.params;

    return (
      <div className="product-edit-page">
        <div className="product-edit-page__wrapper">
          <div className="product-edit-page__header">
            <Header
              pushToClone={this.buttonClone_clickHandler}
              updateStockStatus={this.buttonStockStatus_clickHandler}
              productName={productData.product.name}
              checked={productData.product.active}
              onReturn={this.handleReturn.bind(this)}
              onChangeSwitch={this.handleChangeSwitch.bind(this)}
            />
          </div>
          <div className="product-edit-page__images-container pl-0 pl-lg-5 ml-0 ml-lg-5">
            <ImagesContainer
              images={this.getImagesList(productData)}
              onImagesChange={this.handleImagesChange.bind(this)}
              imageSize="large"
              customStyles="product"
              enableImageSwap={true}
              productId={productData.id}
              isTmp={id === 'tmp_etl'}
              onSwap={this.handleSwap.bind(this)}
            />
          </div>
          <div className="product-edit-page__attributes-from">
            <AttributesForm
              missingRequiredFields={missingRequiredFields}
              productData={productData}
              categories={categories}
              colors={colors}
              materials={materials}
              suppliers={suppliers}
              fxCad={fxCad}
              onRoomVariantLinkClick={(room_id, variant_id) => push(`/rooms/${room_id}/variant/${variant_id}`)}
              onChangeAttribute={this.handleChangeAttributes.bind(this)}
              onCategoryChange={this.handleCategoryChange.bind(this)}
              onSupplierChange={this.handleSupplierChange.bind(this)}
              onColorsChange={this.handleColorsChange.bind(this)}
              onMaterialsChange={this.handleMaterialsChange.bind(this)}
              onChangeOtherAttribute={this.handleChangeOtherAttributes.bind(this)}
              onAddAttribute={this.handleAddAttribute.bind(this)}
              onDeleteAttribute={this.handleDeleteAttribute.bind(this)}
              onChangeRoomPlannerImage={this.handleChangeRoomPlannerImage.bind(this)}
              onDiscontinuedChange={this.handleDiscontinuedChange.bind(this)}
            />
          </div>
          <div className="mt-md-5 mb-md-5 mt-4 mb-2 container">
            <GlobalButtons onSave={this.handleSave.bind(this)} onCancel={this.handleReturn.bind(this)} />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    furniture: furnitureSelector(state),
    loading: loadingSelector(state),
    product: productSelector(state),
    productOptions: productOptionsSelector(state),
    error: state.product.error,
  }),
  {
    createProduct,
    getFurniture,
    getProduct,
    getProductOptions,
    goBack,
    push,
    updateProduct,
    updateStockStatusProduct,
  }
)(Product);
